import { IDisclaimerPosition, IDisclaimerWidth } from 'src/interfaces';
import { lang } from 'src/utils';

import { LayoutBuilder } from '../LayoutBuilder';
import { ILayoutBuilderWithDisclaimer } from './LayoutBuilderWithDisclaimer.interface';
import {
  DisclaimerBox,
  DisclaimerContainer,
  GridContainer,
} from './LayoutBuilderWithDisclaimer.styles';

export const LayoutBuilderWithDisclaimer = ({
  gridSections,
  rows,
  cols,
  dynamicRatio,
  cellHeight,
  cellWidth,
  setGridSections,
  disclaimerPosition,
  disclaimerType,
  disclaimerHeightScaled,
  disclaimerWidth,
  isRecommendationEnabled,
  onActiveSectionChange,
  onGridSectionsChange,
  canDeleteCurrentSelectedSection = true,
  sectionFontSize,
  isScheduleComponent,
  transformScale,
}: ILayoutBuilderWithDisclaimer) => {
  return (
    <GridContainer $dynamicRatio={dynamicRatio} spacing={2}>
      {disclaimerPosition === IDisclaimerPosition.TOP && (
        <DisclaimerContainer>
          <DisclaimerBox
            height={disclaimerHeightScaled}
            width={disclaimerWidth}
            $sectionFontSize={sectionFontSize}>
            {lang.disclaimer} 1
          </DisclaimerBox>
          {disclaimerType === IDisclaimerWidth.HALF && (
            <DisclaimerBox
              height={disclaimerHeightScaled}
              width={disclaimerWidth}
              $sectionFontSize={sectionFontSize}>
              {lang.disclaimer} 2
            </DisclaimerBox>
          )}
        </DisclaimerContainer>
      )}

      <LayoutBuilder
        gridSections={gridSections}
        rows={rows}
        cols={cols}
        dynamicRatio={dynamicRatio}
        cellHeight={cellHeight}
        cellWidth={cellWidth}
        setGridSections={setGridSections}
        isRecommendationEnabled={isRecommendationEnabled}
        onActiveSectionChange={onActiveSectionChange}
        onGridSectionsChange={onGridSectionsChange}
        canDeleteCurrentSelectedSection={canDeleteCurrentSelectedSection}
        sectionFontSize={sectionFontSize}
        isScheduleComponent={isScheduleComponent}
        transformScale={transformScale}
      />

      {disclaimerPosition === IDisclaimerPosition.BOTTOM && (
        <DisclaimerContainer>
          <DisclaimerBox
            height={disclaimerHeightScaled}
            width={disclaimerWidth}
            $sectionFontSize={sectionFontSize}>
            {lang.disclaimer} 1
          </DisclaimerBox>
          {disclaimerType === IDisclaimerWidth.HALF && (
            <DisclaimerBox
              height={disclaimerHeightScaled}
              width={disclaimerWidth}
              $sectionFontSize={sectionFontSize}>
              {lang.disclaimer} 2
            </DisclaimerBox>
          )}
        </DisclaimerContainer>
      )}
    </GridContainer>
  );
};
